module.exports = __webpack_public_path__ + "img/logo_new.294531d6.png";